<template>
  <div class="container wizard">
    <div class="row">
      <div class="col-12 p-0">
        <h2>Documento con Firma Digital</h2>
      </div>
    </div>
    <div class="row content">
      <iframe
        v-if="url !== ''"
        :src="url"
        width="100%"
        height="900px"
        @load="loadIFrame"
      ></iframe>
      <b-alert v-else-if="error" show variant="danger">
        {{ error }}
      </b-alert>
    </div>
  </div>
</template>

<script>
import FormService from "../../../services/form.service";

export default {
  data() {
    return {
      url: "",
      error: "",
    };
  },
  computed: {
    form() {
      return this.$store.state.wizard.form;
    },
  },
  mounted() {
    this.$store.dispatch("app/loading", true);
    const { form } = this.$store.state.wizard;
    if (!form) {
      this.$router.push("/form/colombia/");
      return;
    }
    FormService.send(form)
      .then((response) => {
        this.getPdfInterval(response.data.eviID);
      })
      .catch((err) => {
        this.$store.dispatch("app/loading", false);
        this.error =
          (err.response && err.response.data && err.response.data.message) ||
          "Error al enviar el documento a firma. Contacte con soporte.";
      });
  },
  methods: {
    getPdfInterval(uniqueId) {
      const $this = this;
      function requestIntervalFunction(uid) {
        try {
          FormService.status({ uniqueId: uid }).then((response) => {
            if (response.data.statusCode === "200") {
              const url = response.data.bulkSignUrl;
              const signIn = response.data.signIn;
              if (signIn === "True" || signIn === "False") {
                $this.$store.dispatch("app/loading", false);
                $this.$store.dispatch("wizard/accepted", signIn === "True");
                clearInterval(requestIntervalId);
                $this.next();
              }
              if ($this.url === "" && url) {
                $this.url = url;
              }
            }
          });
        } catch {
          $this.$store.dispatch("app/loading", false);
          $this.$bvToast.toast("Contacte con soporte de Evicertia", {
            title: "Error al recuperar el PDF",
            variant: "danger",
            solid: true,
          });
        }
      }
      const requestIntervalId = setInterval(requestIntervalFunction, 2000, uniqueId);
      setTimeout(() => {
        this.$store.dispatch("app/loading", false);
        clearInterval(requestIntervalId);
      }, 120000);
    },
    loadIFrame(e) {
      if (e.target.src !== "") {
        this.$store.dispatch("app/loading", false);
      }
    },
    next() {
      this.$router.push("/form/colombia-6.html");
    },
  },
};
</script>
